import PropTypes from "prop-types";

/**
 *
 * @param {string} width
 * @param {string} height
 * @param {string} pathFill
 * @returns {JSX.Element}
 * @constructor
 */
export default function Dropdown({ width = '10', height = '8', pathFill = '#4E4E4E' }) {
    return (
        <svg width={width} height={height} viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L4.57143 8L9.14286 0H0Z" fill={pathFill} />
        </svg>
    )
}

Dropdown.PropTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    pathFill: PropTypes.string,
}
